import type {
  CustomViewAttribute,
  CustomViewFormConditionField,
} from 'src/graphql/entities/custom-view/custom-view.types';
import type { CustomViewCustomAttributeCatalog } from './use-custom-view-custom-attributes';

type CustomViewConfigCollections = {
  attributesList: CustomViewAttribute[];
  attributesMap: Map<string, CustomViewAttribute>;
  filterAttributesList: CustomViewFormConditionField[];
  filterAttributesMap: Map<string, CustomViewFormConditionField>;
};

type CustomAttributeCatalog = Pick<
  CustomViewCustomAttributeCatalog,
  'columnDescriptors' | 'filterDescriptors'
>;

export function withCustomAttributes<T extends CustomViewConfigCollections>(
  config: T,
  catalog: CustomAttributeCatalog,
): T {
  const { columnDescriptors: columns, filterDescriptors: filters } = catalog;

  if (columns.length === 0 && filters.length === 0) {
    return config;
  }

  const attributesMap = new Map(config.attributesMap);
  const attributesList = [...config.attributesList];

  for (const column of columns) {
    if (attributesMap.has(column.attribute)) {
      continue;
    }

    attributesMap.set(column.attribute, column);
    attributesList.push(column);
  }

  const filterAttributesMap = new Map(config.filterAttributesMap);
  const filterAttributesList = [...config.filterAttributesList];

  for (const filter of filters) {
    if (filterAttributesMap.has(filter.value)) {
      continue;
    }

    filterAttributesMap.set(filter.value, filter);
    filterAttributesList.push(filter);
  }

  return {
    ...config,
    attributesList,
    attributesMap,
    filterAttributesList,
    filterAttributesMap,
  };
}
